















import { Component, Prop, Vue } from 'vue-property-decorator'

const DRAW_LINE_WIDTH = 5
const ERASER_LINE_WIDTH = 15
@Component
export default class PenCanvas extends Vue {
  @Prop()
  name!: string

  private isDrawable = false
  private lineWidth = DRAW_LINE_WIDTH
  private canvas: HTMLCanvasElement | null = null
  private context: CanvasRenderingContext2D | null = null
  private isDrag = false
  private penColor = '#333333'
  private alpha = 1
  private compositeOperation = 'source-over'

  private get refs(): any {
    return this.$refs
  }

  private mounted() {
    if (!Vue.prototype.$penCanvases) Vue.prototype.$penCanvases = {}
    Vue.prototype.$penCanvases[this.name] = this
    this.canvas = this.refs['penCanvas']
    if (!this.canvas) return
    this.context = this.canvas.getContext('2d')
  }

  private activateCanvas() {
    this.isDrawable = true
  }

  private deactivateCanvas() {
    this.isDrawable = false
  }

  /**
   * canvasのサイズ変更
   */
  private changeSize({ width = 0, height = 0 }: { width: number; height: number }): void {
    if (!this.canvas) return
    this.canvas.width = width
    this.canvas.height = height
    this.setCanvasContext()
  }

  /**
   * canvasのパラメータ設定
   */
  private setCanvasContext(): void {
    if (!this.context) return
    this.context.globalCompositeOperation = this.compositeOperation
    this.context.lineCap = 'round'
    this.context.lineJoin = 'round'
    this.context.lineWidth = this.lineWidth
    this.context.strokeStyle = this.penColor
    this.context.globalAlpha = this.alpha
  }

  /**
   * ペンの種類を設定
   */
  private changePenType({ colorCode, alpha = 1 }: { colorCode: string; alpha: number }): void {
    this.lineWidth = DRAW_LINE_WIDTH
    this.penColor = colorCode
    this.alpha = alpha
    this.compositeOperation = 'source-over'
    this.setCanvasContext()
  }

  /**
   * canvasに消しゴム設定
   */
  private setEraser(): void {
    this.lineWidth = ERASER_LINE_WIDTH
    this.compositeOperation = 'destination-out'
    this.alpha = 1
    this.setCanvasContext()
  }

  /**
   * 描画
   */
  private draw(e: any): void {
    e.preventDefault() // スクロール抑制
    if (!this.context || !this.isDrag) return

    const { x, y } = this.caliculatePosition(e)
    this.context.lineTo(x, y)
    this.context.stroke()
  }

  /**
   * 描画開始
   */
  private dragStart(e: any): void {
    e.preventDefault() // スクロール抑制
    if (!this.context) return

    const { x, y } = this.caliculatePosition(e)
    this.context.beginPath()
    this.context.lineTo(x, y)
    this.context.stroke()

    this.isDrag = true
  }

  /**
   * 描画終了
   */
  private dragEnd(): void {
    if (!this.context) return
    this.context.closePath()
    this.isDrag = false
  }

  /**
   * 描画座標を取得
   */
  private caliculatePosition(e: any): any {
    // スマホの場合とで描画座標の取得方法が異なる
    if (!this.canvas) return
    let [x, y] = [e.offsetX, e.offsetY]
    // スマホ対応
    if (e.touches !== undefined) {
      if (!this.canvas) return
      const client = this.canvas.getBoundingClientRect()
      x = e.touches[0].pageX - client.left
      y = e.touches[0].pageY - client.top
    }

    return { x, y }
  }
}
